// Fix duplicate import
import React, { useState, useEffect, useRef } from "react";
import Login from "./components/Login";
import Signup from "./components/Signup";
import ResetPassword from "./components/ResetPassword";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import EditDashboard from "./components/EditDashboard.jsx";
import "./App.css";
import LandInfoAndCalculation from "./components/LandInfoAndCalculation.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";

function App() {
  const [showSignup, setShowSignup] = useState(false);
  const [authMessage, setAuthMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);
  const [showEditDashboard, setShowEditDashboard] = useState(false);
  const tableRef = useRef();

  // Simple routing check
  const isResetPasswordPage = window.location.pathname === '/reset-password';
  const isPrivacyPolicyPage = window.location.pathname === '/privacy-policy';

  useEffect(() => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");
    const role = localStorage.getItem("role");
    if (token && email && role) {
      setIsLoggedIn(true);
      setUserEmail(email);
      setUserRole(role);
    }
  }, []);

  useEffect(() => {
    if (!authMessage) return;

    const timeout = setTimeout(() => {
      setAuthMessage("");
    }, 3000);

    return () => clearTimeout(timeout);
  }, [authMessage]);

  useEffect(() => {
    console.log("mame inge paru !!! ");
    const syncLogout = (e) => {
      if (e.key === "token" && !e.newValue) {
        console.log("Token removed in another tab. Logging out...");
        handleLogout();
      }
    };

    window.addEventListener("storage", syncLogout);
    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, []);

  const handleLoginSuccess = (email, role) => {
    setIsLoggedIn(true);
    setUserEmail(email);
    setUserRole(role);
    localStorage.setItem("email", email);
    localStorage.setItem("role", role);
    setAuthMessage("Login successful!");
  };

  const handleSignupSuccess = () => {
    setAuthMessage("Signup successful! Please login.");
    setShowSignup(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    setIsLoggedIn(false);
    setUserEmail("");
    setUserRole("");
    setAuthMessage("Logged out successfully.");
    setShowSignup(false);
    setShowAdminDashboard(false);
    setShowEditDashboard(false);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleShowAdminDashboard = () => {
    setShowAdminDashboard(true);
    setShowEditDashboard(false);
  };

  const handleShowEditDashboard = () => {
    setShowEditDashboard(true);
    setShowAdminDashboard(false);
  };

  const handleBackToDashboard = () => {
    setShowAdminDashboard(false);
    setShowEditDashboard(false);
  };

  // If on reset password page, show that component
  if (isResetPasswordPage) {
    return (
      <div className="app-container">
        <div className="auth-layout">
          <div className="auth-image-section">
            <img
              src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Modern House"
            />
          </div>
          <div className="auth-form-section">
            <div className="auth-card">
              <div className="main-header">
                <img
                  className="img-logo"
                  src="/Casagrand-Logo1.webp"
                  alt="logo"
                  width={200}
                />
                <h2 className="padding-10 liac-header">
                  Reset Password
                </h2>
              </div>
              <ResetPassword onNavigateToLogin={() => window.location.href = '/'} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If on privacy policy page, show that component
  if (isPrivacyPolicyPage) {
    return (
      <div className="app-container" style={{ backgroundColor: "#f9fafb", minHeight: "100vh" }}>
        <PrivacyPolicy />
      </div>
    );
  }

  return (
    <div className="app-container">
      {isLoggedIn ? (
        <>
          {/* <div className="header-controls">
            {(userRole === "admin" || userRole === "superuser") && (
              <>
                <button
                  onClick={handleShowAdminDashboard}
                  className="btn btn-secondary"
                  style={{ marginRight: '10px' }}
                >
                  Admin Dashboard
                </button>
                {userRole === "admin" && (
                  <button
                    onClick={handleShowEditDashboard}
                    className="btn btn-secondary"
                  >
                    Edit
                  </button>
                )}
              </>
            )}
            <button onClick={handleLogout} className="btn btn-danger">
              Logout
            </button>
            {!showAdminDashboard && !showEditDashboard && (
              <button onClick={handlePrint} className="btn print-btn">
                Print
              </button>
            )}
          </div> */}
          {showAdminDashboard ? (
            <AdminDashboard
              onBackToDashboard={handleBackToDashboard}
              onShowEditDashboard={handleShowEditDashboard}
            />
          ) : showEditDashboard ? (
            <EditDashboard onBackToDashboard={handleBackToDashboard} />
          ) : (
            <>
              {/* <Dashboard
                userEmail={userEmail}
                handleLogout={handleLogout}
                tableRef={tableRef}
              ></Dashboard> */}
              <LandInfoAndCalculation
                handleLogout={handleLogout}
              ></LandInfoAndCalculation>
            </>
          )}
        </>
      ) : (
        <div className="auth-layout">
          <div className="auth-image-section">
            <img
              src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Modern House"
            />
          </div>

          <div className="auth-form-section">
            <div className="auth-card">
              <div className="main-header">
                <img
                  className="img-logo"
                  src="/Casagrand-Logo1.webp"
                  alt="logo"
                  width={200}
                />
                <h2 className="padding-10 liac-header">
                  Land Info and Calculation
                </h2>
              </div>

              {!showSignup ? (
                <Login
                  onLoginSuccess={handleLoginSuccess}
                  onSwitchToSignup={() => setShowSignup(true)}
                />
              ) : (
                <Signup
                  onSignupSuccess={handleSignupSuccess}
                  onSwitchToLogin={() => setShowSignup(false)}
                />
              )}

              <div className="footer-text">
                © 2025 Developed and Designed By{" "}
                <a
                  href="https://digilogy.co/"
                  target="_blank"
                  className="footer-link"
                >
                  Digilogy
                </a>
                . All rights reserved.
                <div style={{ marginTop: '10px' }}>
                  <a href="/privacy-policy" className="footer-link" style={{ textDecoration: 'underline', fontSize: '0.7rem' }}>Privacy Policy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {authMessage && !isLoggedIn && (
        <div
          className={`message ${authMessage.includes("successful") ? "success" : "error"
            }`}
        >
          {authMessage}
        </div>
      )}

      {/* Footer - Only show when logged in */}
      {isLoggedIn && (
        <footer className="app-footer">
          <div className="footer-content">
            <div className="footer-divider"></div>
            <div className="footer-copyright">
              <div className="footer-copyright-with-image">
                <span>
                  © 2025 Developed and Designed By{" "}
                  <a
                    href="https://digilogy.co/"
                    target="_blank"
                    className="footer-link"
                  >
                    Digilogy
                  </a>
                  . All rights reserved.
                </span>
                {/* <img
                  src="https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg?auto=compress&cs=tinysrgb&w=100&h=50"
                  alt="Digitogy Logo"
                  className="footer-copyright-image"
                /> */}
                {/* <span>Digilogy. All rights reserved.</span> */}
              </div>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}

export default App;
